const initialState = {
  isAuthenticated: false,
  user: null,
  token: null
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case "AUTH/LOGIN_SUCCESS":
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload.user,
        token: action.payload.token
      };
    case "AUTH/LOGOUT":
      return {
        ...state,
        isAuthenticated: false,
        user: null,
        token: null
      };
    default:
      return state;
  }
}

